import React from 'react';
import { Button, PageHeader } from 'components';
import { Form, Input, Row, Col, InputNumber, Switch } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import styles from './style.module.scss';
import { useTranslation } from 'react-i18next';
import useShoppingCenter from '../useShoppingCenter';

const ShoppingCenterEdit = ({ isNew }) => {
  const { t } = useTranslation();
  const { handleCreateOrUpdateShop, form, updateInProcess } =
    useShoppingCenter(false);

  const onFinish = async (values) => {
    await handleCreateOrUpdateShop(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const title = isNew ? 'Nuova sorgente agente' : 'Modifica sorgente agente';

  const handleCreate = () => {
    form.submit();
  };

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label='Nome sorgente'
                name='source_name'
                rules={[{ required: true, message: 'Obbligatorio' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label='URL sorgente'
                name='source_url'
                rules={[{ required: true, message: 'Obbligatorio' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label='Profondità crawl (1–5)'
                name='crawl_depth'
              >
                <InputNumber min={1} max={5} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label='Segui link esterni'
                name='follow_external'
                valuePropName='checked'
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label='Numero massimo di pagine' name='max_pages'>
                <InputNumber min={1} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label='Limite caratteri contenuto'
                name='content_char_limit'
              >
                <InputNumber min={1} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label='Timeout richiesta (secondi)'
                name='request_timeout'
              >
                <InputNumber min={1} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label='Testo “carica altro”' name='load_more_text'>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                label='Clic massimi “carica altro”'
                name='load_more_max_clicks'
              >
                <InputNumber min={0} style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label='Browser headless (JS)'
                name='use_js'
                valuePropName='checked'
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={handleCreate}
              width={'150px'}
              big
              icon={<CheckOutlined />}
              loading={updateInProcess}
            >
              {t('Invia')}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ShoppingCenterEdit;
